import styled from 'styled-components'

import { GeneralInformationForm } from './components'

const WrappedGeneralInformationForm = styled(GeneralInformationForm)`
  margin-bottom: 50px;
`

export const s = { WrappedGeneralInformationForm }
